import React from 'react';
import { ValidIncentiveValue } from 'src/payments/hooks/shared/incentive-types';
import One from './one';
import Two from './two';
import Three from './three';
import Five from './five';
import Seven from './seven';
import Ten from './ten';
import Fifteen from './fifteen';
import Twenty from './twenty';
import TwentyFive from './twenty-five';
import Thirty from './thirty';

type MultiDiscountProps = {
  amount: ValidIncentiveValue;
};

function MultiDiscount({ amount }: MultiDiscountProps): JSX.Element | null {
  const getDiscountComponent = (discountAmount: number): JSX.Element | null => {
    switch (discountAmount) {
      case 1:
        return <One />;
      case 2:
        return <Two />;
      case 3:
        return <Three />;
      case 5:
        return <Five />;
      case 7:
        return <Seven />;
      case 10:
        return <Ten />;
      case 15:
        return <Fifteen />;
      case 20:
        return <Twenty />;
      case 25:
        return <TwentyFive />;
      case 30:
        return <Thirty />;
      default:
        // No matching discount graphic found, don't render anything
        return null;
    }
  };

  return getDiscountComponent(amount);
}

export default MultiDiscount;
